<div class="container-fluid">
    <app-pagetitle title="Customers" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
    
    
    <div class="page-content-wrapper">
        
        <app-loader [loading]="loading"></app-loader>
        
        <div [class.loading-content]="loading">

            
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)" [statusOptions]="statusOptions"
                                [planOptions]="planOptions" searchBY="Name, Email, Company & Phone "></app-filter>

                            <p-table #dt [value]="customers" [lazy]="true" (onLazyLoad)="loadCustomers($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Plan</th>
                                        <th>Status</th>
                                        <th>Company</th>
                                        <th>Phone</th>
                                        <th>Documents</th>
                                        <th>Created</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-customer>
                                    <tr>
                                        <td>{{ customer.name }}</td>
                                        <td>{{ customer.email }}</td>
                                        <td>{{ customer.plan }}</td>

                                        <td>
                                            <div class="badge font-size-12" [ngClass]="{
                            'bg-success-subtle text-success': customer.status === 'Active',
                            'bg-warning-subtle text-warning': customer.status === 'Trial',
                            'bg-danger-subtle text-danger': customer.status === 'Inactive'
                        }">
                                                {{ customer.status }}
                                            </div>
                                        </td>

                                        <td>{{ customer.company }}</td>
                                        <td>{{ customer.phone }}</td>
                                        <td class="text-center">{{ customer.documents }}</td>
                                        <td>{{ customer.createdAt | date:'short' }}</td>

                                        <td class="d-flex align-items-center gap-2">
                                            <div class="form-check form-switch cursor-pointer">
                                                <input class="form-check-input cursor-pointer" type="checkbox"
                                                    [checked]="customer.status !== 'Inactive'"
                                                    (change)="toggleUserStatus(customer, $event)" [ngbTooltip]="customer.status !== 'Inactive'
                                  ? 'Deactivate Customer'
                                  : 'Activate Customer'" />
                                            </div>

                                            <a href="javascript:void(0);" class="text-primary"
                                                (click)="viewInfo(customer)" ngbTooltip="Customer Orders">
                                                <i class="mdi mdi-information font-size-18"></i>
                                            </a>

                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No customers found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>